<div class="tw-flex tw-justify-center tw-h-full tw-flex-col tw-gap-6 tw-py-8 tw-px-16">
  <div class="tw-self-center tw-relative">
    <div class="tw-relative tw-w-20 tw-h-20">
      <svg class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw--rotate-90" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="#E5E7EB"
          stroke-width="8"
        />
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="#0F93CC"
          stroke-width="8"
          [attr.stroke-dasharray]="(percentage / 100) * 283 + ' 283'"
          stroke-linecap="round"
        />
      </svg>
      <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
        <i class="fas fa-user tw-text-3xl tw-text-gray-400"></i>
      </div>
    </div>
  </div>

  <span class="tw-self-center tw-text-[20px] tw-font-medium tw-text-main-text tw-font-['Rubik']">
    {{ 'complete_profile.title' | translate:{ username: username } }}
  </span>

  <p class="tw-text-center tw-text-[18px] tw-font-normal tw-text-main-text tw-leading-relaxed tw-max-w-md tw-mx-auto tw-font-['Rubik']">
    {{ 'complete_profile.description' | translate }}
  </p>

  <div class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-8 tw-mt-4">
    <span 
      class="tw-text-[#979797] tw-text-[16px] tw-font-bold tw-cursor-pointer hover:tw-text-gray-700 tw-font-['Rubik']"
      (click)="handleSkip()"
    >
      {{ 'complete_profile.skip_button' | translate }}
    </span>
    
    <mh-core-lib-button
      [isPrimary]="true"
      [text]="'complete_profile.complete_button' | translate"
      [customClass]="'!tw-shadow-none'"
      [textClass]="'tw-font-[Rubik]'"
      width="200"
      (clicked)="handleComplete()"
    ></mh-core-lib-button>
  </div>
</div>
